<template>
  <div class="c-tab-wrapped">
    <slot name="title"></slot>
    <ul class="c-tab-wrapped__container">
      <f-tab-wrapped-item
        v-for="(item, index) in items"
        :item="item"
        @tab-item-clicked="onTabItemClicked(index)"
      ></f-tab-wrapped-item>
    </ul>
  </div>
</template>

<script>
import FTabWrappedItem from '~/js/components/tabWrapped/item'

export default {
  name: 'ComponentTabWrapped',
  props: {
    items: { type: Array },
  },
  components: { FTabWrappedItem },
  methods: {
    onTabItemClicked(index) {
      this.$emit('tab-item-clicked', index)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';

.c-tab-wrapped {
  background-color: variables.$color-accent-weak;
  border-radius: 8px;
  padding: 24px 8px;

  &__container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
  }
}
</style>
